import { render, staticRenderFns } from "./ChangePasswordPage.vue?vue&type=template&id=1ba19d2d&scoped=true&"
import script from "./ChangePasswordPage.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordPage.vue?vue&type=style&index=0&id=1ba19d2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba19d2d",
  null
  
)

export default component.exports